/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.PublicExternalLink = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The PublicExternalLink model module.
   * @module model/PublicExternalLink
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>PublicExternalLink</code>.
   * @alias module:model/PublicExternalLink
   * @class
   */
  var exports = function() {
    var _this = this;















  };

  /**
   * Constructs a <code>PublicExternalLink</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PublicExternalLink} obj Optional instance to populate.
   * @return {module:model/PublicExternalLink} The populated <code>PublicExternalLink</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('CreatedBy')) {
        obj['CreatedBy'] = ApiClient.convertToType(data['CreatedBy'], 'Integer');
      }
      if (data.hasOwnProperty('Created')) {
        obj['Created'] = ApiClient.convertToType(data['Created'], 'Date');
      }
      if (data.hasOwnProperty('TypeID')) {
        obj['TypeID'] = ApiClient.convertToType(data['TypeID'], 'Integer');
      }
      if (data.hasOwnProperty('IdentifierGuid')) {
        obj['IdentifierGuid'] = ApiClient.convertToType(data['IdentifierGuid'], 'String');
      }
      if (data.hasOwnProperty('Title')) {
        obj['Title'] = ApiClient.convertToType(data['Title'], 'String');
      }
      if (data.hasOwnProperty('LanguageID')) {
        obj['LanguageID'] = ApiClient.convertToType(data['LanguageID'], 'Integer');
      }
      if (data.hasOwnProperty('RefreshTimeout')) {
        obj['RefreshTimeout'] = ApiClient.convertToType(data['RefreshTimeout'], 'Integer');
      }
      if (data.hasOwnProperty('DashboardPageID')) {
        obj['DashboardPageID'] = ApiClient.convertToType(data['DashboardPageID'], 'Integer');
      }
      if (data.hasOwnProperty('PageFilterDataJSON')) {
        obj['PageFilterDataJSON'] = ApiClient.convertToType(data['PageFilterDataJSON'], 'String');
      }
      if (data.hasOwnProperty('AlertID')) {
        obj['AlertID'] = ApiClient.convertToType(data['AlertID'], 'Integer');
      }
      if (data.hasOwnProperty('WorkshopID')) {
        obj['WorkshopID'] = ApiClient.convertToType(data['WorkshopID'], 'Integer');
      }
      if (data.hasOwnProperty('DialogScheduleBatchID')) {
        obj['DialogScheduleBatchID'] = ApiClient.convertToType(data['DialogScheduleBatchID'], 'Integer');
      }
      if (data.hasOwnProperty('PageUrl')) {
        obj['PageUrl'] = ApiClient.convertToType(data['PageUrl'], 'String');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} CreatedBy
   * @default 0
   */
  exports.prototype['CreatedBy'] = 0;
  /**
   * @member {Date} Created
   */
  exports.prototype['Created'] = undefined;
  /**
   * @member {Integer} TypeID
   * @default 0
   */
  exports.prototype['TypeID'] = 0;
  /**
   * @member {String} IdentifierGuid
   * @default ''
   */
  exports.prototype['IdentifierGuid'] = '';
  /**
   * @member {String} Title
   * @default ''
   */
  exports.prototype['Title'] = '';
  /**
   * @member {Integer} LanguageID
   * @default 0
   */
  exports.prototype['LanguageID'] = 0;
  /**
   * @member {Integer} RefreshTimeout
   */
  exports.prototype['RefreshTimeout'] = undefined;
  /**
   * @member {Integer} DashboardPageID
   */
  exports.prototype['DashboardPageID'] = undefined;
  /**
   * @member {String} PageFilterDataJSON
   * @default ''
   */
  exports.prototype['PageFilterDataJSON'] = '';
  /**
   * @member {Integer} AlertID
   */
  exports.prototype['AlertID'] = undefined;
  /**
   * @member {Integer} WorkshopID
   */
  exports.prototype['WorkshopID'] = undefined;
  /**
   * @member {Integer} DialogScheduleBatchID
   */
  exports.prototype['DialogScheduleBatchID'] = undefined;
  /**
   * @member {String} PageUrl
   * @default ''
   */
  exports.prototype['PageUrl'] = '';
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


